module.exports = __webpack_public_path__ + "static/media/client3.97617fb8.png";